/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {removeBrandHeroImage} from '../api'

export const useMutationRemoveBrandHeroImage = createReactQueryMutationHook('removeBrandHeroImage', removeBrandHeroImage)
